// extracted by mini-css-extract-plugin
export var link = "index-module--link--2B8l1";
export var linkActive = "index-module--link-active--LIQAR";
export var root = "index-module--root--pzxoN";